import ReactOnRails from 'react-on-rails'
import MainSite from './bundles/MainSite/components/MainSite'
import './application.scss'

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  MainSite
})
